/**
 * Моковые настройки безопасности: ручек под них нет.
 */
export const CEO_ANALYTICS_SECURITY_CONFIG = {
  CEO_ANALYTICS_PIN: '1234',
  maxAttempts: 3,
  lockTimeMinutes: 5,
} as const;
